import { render, staticRenderFns } from "./CancelledIcon.vue?vue&type=template&id=3c21e970"
import script from "./CancelledIcon.vue?vue&type=script&lang=ts"
export * from "./CancelledIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports